import React, { useState, useEffect } from 'react';
import { Button, Card, Container, Modal } from 'react-bootstrap';
import { axios, getAxiosConfig } from '../utils/apiUtils';
import { updateUser } from '../utils/authUtils';

const styles = {
  main:{
    paddingTop: 36,
  }
};

const Subscribe = () => {

  const handleCreditCard = () => {
    axios.post(
      `${process.env.REACT_APP_API_URL}/payments/creditcard`,
      {},
      getAxiosConfig(),
    )
    .then((creditCardResponse) => {
      window.location.replace(`${creditCardResponse.data.redirectTo}?token=${creditCardResponse.data.token}`)
    })
    .catch((progressError) => {
      console.error("Couldn't send progress to chungungo servers > "+progressError.message);
    });
  };

  const handleSubscription = () => {
    axios.post(
      `${process.env.REACT_APP_API_URL}/payments/subscription/new`,
      {},
      getAxiosConfig(),
    )
    .then((subscriptionResponse) => {
      updateUser({
        user: subscriptionResponse.data.user
      });
      console.debug(subscriptionResponse.data.subscription);
    })
    .catch((subscriptionError) => {
      console.debug(subscriptionError);
    });
  }

  return (
    <Container style={styles.main}>
      <h1>Suscribirse</h1>
      <p>Conoce todos los beneficios de una suscripción a chungungo!</p>

      <Card>
        <Button variant="primary" onClick={handleCreditCard}>Agregar Tarjeta de crédito</Button>
        <Button variant="success" onClick={handleSubscription}>Suscribirse</Button>
        <Button variant="danger">Desuscribirse</Button>
      </Card>
    </Container>
  );
};

export default Subscribe;

